export default __webpack_public_path__ + "cba209b0f24424ae93ca94fca27f1bfa.ttf";